import TabPage from "../../../projectx/factories/tab-page";
import "./../../factories/shift-schedule-swap-employees-dialog";
import "../../../projectx/bindings/bao-searcher";
import * as $ from "jquery";
import Bao from "../../../projectx/services/bao-service";
import * as ko from "knockout";
import BaoDialog from "../../../projectx/factories/bao-dialog";
import { ShiftbookType } from "../../constants/shiftbook-type";
import baoRouter from "../../../projectx/services/bao-router";

/**
 * view-model for QualificationOverview report in report center
 */
class QualificationManagementReport {
    Bao = Bao;
    TabPage: TabPage;
    Parent;
    ReportHTML: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    CellOverlay: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    Overview: KnockoutObservableArray<any> = ko.observableArray([]);
    HeaderLeft: KnockoutObservable<string> = ko.observable('0');
    SidebarTop: KnockoutObservable<string> = ko.observable('0');
    ShiftBookIds = ko.observable();
    ShiftBookName = ko.observable();
    SearchShiftGroup = ko.observable();
    QualificationIds = ko.observable();
    ShiftGroupIds = ko.observable();
    ShiftGroup = ko.observable();
    Qualification = ko.observable();
    QualificationType = ko.observable();
    QualificationTypeName = ko.observable();
    QualificationTypeIds = ko.observable();
    QualificationCollection = ko.observableArray();
    ValidTo = ko.observable();
    ValidFrom = ko.observable();
    ShiftBook = ko.observable();
    ShiftGroups = ko.observableArray();
    Qualifications = ko.observableArray();
    QualificationTypes = ko.observableArray();

    SearcherShiftBook: Bindings.baoSearcher = {
        ObjectId: this.ShiftBookIds,
        ObjectValue: 'Name',
        SearchType: 'ShiftBook',
        SelectedItem: this.ShiftBook,
        AutoComplete: true,
        AutoSearch: true,
        MultiSelect: true,
        CustomFilter: {
            CurrentUserHasReadPermission: true,
            ShiftbookTypeId: ShiftbookType.ShiftBook
        }
    };

    SearcherShiftGroup: Bindings.baoSearcher = {
        ObjectId: this.ShiftGroupIds,
        ObjectValue: 'Name',
        SearchType: 'ShiftGroup',
        SelectedItem: this.ShiftGroups,
        AutoComplete: true,
        AutoSearch: true,
        MultiSelect: true,
        CustomFilter: { CurrentUserHasReadPermission: true }
    };

    SearcherQualification: Bindings.baoSearcher = {
        ObjectId: this.QualificationIds,
        ObjectValue: 'Name',
        SearchType: 'Qualification',
        SelectedItem: this.Qualifications,
        AutoComplete: true,
        AutoSearch: true,
        MultiSelect: true,
        CustomFilter: { CurrentUserHasReadPermission: true }
    };

    SearcherQualificationType: Bindings.baoSearcher = {
        ObjectId: this.QualificationTypeIds,
        ObjectValue: 'Name',
        SearchType: 'QualificationType',
        SelectedItem: this.QualificationTypes,
        AutoComplete: true,
        AutoSearch: true,
        MultiSelect: true,
        CustomFilter: { CurrentUserHasReadPermission: true }
    };

    /**
    * Fetches the report for the web view
    */
    Display = () => {
        this.TabPage.IsLoading(true);
        this.FetchQualificationManagementReportModel().then(() => this.TabPage.IsLoading(false));
    };

    /**
    * downloads the report as pdf
    */
    Download = () => {
        this.TabPage.IsLoading(true);
        this.DownloadQualificationManagementReport().then(() => {
            this.TabPage.IsLoading(false)
        });
    };

    constructor(parent: any, params: any) {
        this.Parent = parent;
        this.TabPage = parent.TabPage;
    }

    /**
    * fetches the model needed for displaying the report-view
    */
    public FetchQualificationManagementReportModel(): JQueryPromise<void> {
        return Bao.post("ReportCenter/FetchQualificationManagementReportModel", JSON.stringify({
            shiftBookIds: this.ShiftBookIds(),
            shiftGroupIds: this.ShiftGroupIds(), 
            qualificationIds: this.QualificationIds(),
            qualificationTypeIds: this.QualificationTypeIds(),
            validFrom: this.ValidFrom(),
            validTo: this.ValidTo()
        })).then(result => {
            if (result && result.Result) {
                this.QualificationCollection(result.Models);
            } else {
                this.QualificationCollection.removeAll();
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }

    /**
    * exports the report as pdf
    */
    public DownloadQualificationManagementReport(): JQueryPromise<void> {
        return Bao.post("ReportCenter/ExportQualificationManagementReport", JSON.stringify({
            shiftBookIds: this.ShiftBookIds(),
            shiftGroupIds: this.ShiftGroupIds(),
            qualificationIds: this.QualificationIds(),
            qualificationTypeIds: this.QualificationTypeIds(),
            validFrom: this.ValidFrom(),
            validTo: this.ValidTo()
        })).then(result => {
            if (result && result.Result) {
                baoRouter.setHash("document/" + result.Message);
            } else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
}
export default QualificationManagementReport;